import type { SVGProps } from 'react'

export const PizzaSliceChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1665 8.66667C9.10393 8.66667 4.99988 12.7707 4.99988 17.8333C4.99988 22.8959 9.10393 27 14.1665 27C19.2292 27 23.3332 22.8959 23.3332 17.8333H14.1665V8.66667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8332 14.1667H26.9999C26.9999 9.10406 22.8958 5 17.8332 5V14.1667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
